import { Autocomplete, TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IEnseignantItem, IParentStudentItem, setCurrentEtab, setEnseignants } from "../../store/focusEcoleSlice";
import { moisDeLAnnee } from "../constant";


export interface ISearchBarByEtabProps {
  localDatasFiltered: IEnseignantItem[];
  setLocalDatasFiltered: (x: IEnseignantItem[]) => void;
  currentMonth: any;
  setCurrentMonth: any;
}

const SearchMonth = (props: ISearchBarByEtabProps) => {

  const { localDatasFiltered, setLocalDatasFiltered, currentMonth, setCurrentMonth } = props

  const dispatch = useDispatch();
  const { enseignants } = useSelector((state: IReduxState) => state.focusEcole);



  return (
    <Box>
      <Autocomplete
        fullWidth
        onChange={(e: any, mois: any) => {
          if (mois) {
            setCurrentMonth({
              ...currentMonth,
              numero: mois.numero
            });
          }
          else {
            setCurrentMonth({})
            dispatch(setEnseignants([...enseignants]))
            setLocalDatasFiltered([...localDatasFiltered])
          }
        }}
        options={moisDeLAnnee}
        renderOption={(props, mois) => {
          const {nom, numero } = mois;
          const newIndex = moisDeLAnnee.findIndex((item: any) => item.numero === numero)
          return (
            <span {...props}
              style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
            >
              {nom}
            </span>
          );
        }}

        getOptionLabel={(mois) =>
          `${mois.nom}`
        }

        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            fullWidth
            size="small"
            label="Choisir un mois..."
          />
        )}
      />
    </Box>
  );
};
export default SearchMonth;
